import { atom } from 'recoil';

export const showRequestExtensionState = atom<boolean>({
  key: 'showRequestExtension',
  default: false,
});
